"use client";

import React from "react";

import { Progress } from "@/components/ui/progress";

const ariaId = "progressbar-label";

export function ScrollProgressBar() {
  const percent = useScrollPercentage();
  return (
    <div>
      <p id={ariaId} className="sr-only">
        Scroll progress
      </p>
      <Progress
        aria-labelledby={ariaId}
        className="fixed h-[3px] rounded-none"
        value={percent}
      />
    </div>
  );
}

export function useScrollPercentage() {
  const [percent, setPercent] = React.useState(0);

  React.useEffect(() => {
    function onScroll() {
      const scrolled = document.documentElement.scrollTop;
      const height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrolledPercent = Math.min(
        100,
        Math.round((scrolled / height) * 100)
      );
      setPercent(scrolledPercent);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return percent;
}
